import { Link } from "react-router-dom";

export default function Support() {
  return (
    <div className="min-h-screen bg-[#0b0b0f] text-white flex flex-col">
      {/* ───────── HEADER ───────── */}
      <header className="border-b border-white/10 bg-[#0b0b0f]/70 backdrop-blur-md sticky top-0 z-50">
        <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold">
            Ovylon <span className="text-sm text-gray-400 font-medium ml-2">AI Studio</span>
          </Link>
          <div className="flex gap-3">
            <Link
              to="/register"
              className="px-4 py-2 bg-white text-black rounded-lg font-semibold hover:bg-gray-200 transition"
            >
              Crear cuenta
            </Link>
            <Link
              to="/login"
              className="px-4 py-2 border border-white/15 rounded-lg hover:bg-white/10 transition"
            >
              Iniciar sesión
            </Link>
          </div>
        </div>
      </header>

      {/* ───────── CONTENT ───────── */}
      <main className="flex-1 max-w-5xl mx-auto px-6 py-14">
        <div className="text-xs uppercase tracking-[0.25em] text-gray-400">Soporte</div>
        <h1 className="text-3xl md:text-4xl font-bold mt-3">¿Necesitas ayuda?</h1>
        <p className="text-gray-400 mt-4 text-lg max-w-3xl">
          Escríbenos y te respondemos lo más rápido posible. Un soporte claro y accesible
          aumenta la confianza y la conversión.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* EMAIL */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <div className="text-sm font-semibold">Email</div>
            <p className="text-sm text-gray-400 mt-2">
              Para soporte, facturación o preguntas generales:
            </p>
            <div className="mt-4 inline-flex items-center px-4 py-2 rounded-xl border border-white/10 bg-black/30 text-gray-200">
              soporte@ovylon.ai
            </div>
          </div>

          {/* FORM */}
          <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
            <div className="text-sm font-semibold">Formulario rápido</div>
            <p className="text-sm text-gray-400 mt-2">
              Si prefieres, déjanos tu mensaje y te contactamos:
            </p>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                alert("Formulario demo. Conéctalo a tu backend cuando quieras.");
              }}
              className="mt-4 space-y-3"
            >
              <input
                required
                placeholder="Tu email"
                className="w-full px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-gray-100 outline-none focus:ring-2 focus:ring-indigo-500/40 text-sm"
              />
              <textarea
                required
                placeholder="Cuéntanos qué necesitas"
                className="w-full min-h-[120px] px-4 py-3 rounded-xl bg-black/30 border border-white/10 text-gray-100 outline-none focus:ring-2 focus:ring-indigo-500/40 text-sm"
              />
              <button
                type="submit"
                className="w-full px-5 py-3 rounded-xl text-sm font-semibold
                  bg-gradient-to-r from-indigo-500 to-purple-500
                  hover:from-indigo-400 hover:to-purple-400
                  transition shadow-lg shadow-indigo-500/30"
              >
                Enviar mensaje
              </button>
            </form>
          </div>
        </div>

        {/* ✅ BACK LINK */}
        <div className="mt-12">
          <Link to="/" className="text-sm text-gray-300 hover:text-white transition">
            ← Volver al inicio
          </Link>
        </div>
      </main>

      {/* ───────── FOOTER ───────── */}
      <footer className="border-t border-white/10 py-10 text-sm text-gray-500">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>© {new Date().getFullYear()} Ovylon® — All rights reserved.</div>

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/about" className="hover:text-gray-300 transition">
              Qué es Ovylon
            </Link>
            <Link to="/support" className="hover:text-gray-300 transition">
              Soporte
            </Link>
            <Link to="/privacy" className="hover:text-gray-300 transition">
              Privacidad
            </Link>
            <Link to="/terms" className="hover:text-gray-300 transition">
              Términos
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

